import React, { Component } from "react";
import { FiChevronRight, FiMoreVertical } from "react-icons/fi";
import ProductCard from "../../base/features/blocks/ProductCard";
import { orderDetail } from "./services";
import Spinner from "../../base/features/micro/Spinner";
import Image from "../../base/features/micro/Image";
import OrderResult from "./blocks/OrderResult";
import ConnectionsModal from "../../base/features/blocks/ConnectionsModal";
import { fixObject } from "../../base/utils/convert_to_object";
import { navigate_to_shop } from "../../navigator/user/shop";

class OrderDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      order: null,
    };
  }
  componentDidMount() {
    if (window.location.search) {
      let backUrl = fixObject(window.location.search)._back;
      if (backUrl) {
        this.setState({ backUrl: backUrl });
      }
    }
    this.getOrderDetail();
  }
  getOrderDetail() {
    var order_uid = window.location.pathname.split("/")[2];
    orderDetail(order_uid).then((items) => {
      items && this.setState({ order: items });
    });
  }

  navigate_to_order_shop(order) {
    window.location.href = navigate_to_shop(order.shop.uid);
  }

  render() {
    return (
      <div className="container-fluid px-0">
        <header
          className="row mx-0 px-3 py-2-3 position-fixed bg-white shadow-sm"
          style={{ top: "0", right: "0", left: "0", zIndex: "4" }}
        >
          <div className="col-auto align-self-center px-0 ps-4">
            <FiChevronRight
              onClick={() =>
                this.state.backUrl
                  ? (window.location.href = this.state.backUrl)
                  : window.history.back()
              }
              size="26"
              className=""
            />
          </div>

          <div className="col align-self-center text-ثدی px-0">
            <h1 className="fs-6 fw-bold mb-0">پیگیری / جزئیات سفارش</h1>
          </div>
          <div className="col-auto align-self-center px-0">
            <FiMoreVertical size="22" className="" />
          </div>
        </header>
        <body style={{ marginTop: "60px" }}>
          {this.state.order ? (
            this.state.order.items === 0 ? (
              <p className="mt-3 text-center">موردی یافت نشد</p>
            ) : (
              <div className="row mx-0 px-0">
                <div className="row mx-0 px-4 py-3 border-bottom">
                  <div className="col-auto px-1 align-self-center">
                    <Image
                      imageUri={
                        this.state.order.shop
                          ? this.state.order.shop.cover &&
                            this.state.order.shop.cover.thumbnail
                          : this.state.order.user.image
                      }
                      isProfile={true}
                      imageHeight={"50"}
                      imageWidth={"50"}
                      imgClassName={"rounded-circle img-cover"}
                      extraClassName={"p-0 img-contain rounded-0"}
                    />
                  </div>
                  <div
                    className="col px-1 align-self-center"
                    onClick={() =>
                      this.navigate_to_order_shop(this.state.order)
                    }
                  >
                    <p className="fw-bolder mb-0 fs-6">
                      {this.state.order.shop
                        ? this.state.order.shop.title
                        : this.state.order.user.name}
                      {this.state.order.shop &&
                        this.state.order.shop.is_verify && (
                          <img
                            width="15"
                            className="me-1"
                            alt="verify"
                            src={
                              require("../../base/assets/icons/verify.svg")
                                .default
                            }
                          />
                        )}
                    </p>
                    <p className="fw-bolder mb-0 fs-7 text-muted">
                      {this.state.order.shop.sub_title}
                    </p>
                  </div>
                  <div
                    className="col-auto px-1 align-self-center color-main small fw-bold"
                    onClick={() => this.setState({ phoneDetail: true })}
                  >
                    تماس با فروشنده
                  </div>
                  {this.state.phoneDetail && (
                    <ConnectionsModal
                      phone={this.state.order.shop.call_center}
                      connectionsModalChange={(value) =>
                        this.setState({ phoneDetail: value })
                      }
                      connectionsModal={this.state.phoneDetail}
                    />
                  )}
                </div>
                <OrderResult order={this.state.order} />
                <div className="col-12 px-4 mt-3 fs-6">
                  <p className="mb-0 text-muted">
                    اقلام سفارش | {this.state.order.total_quantity}
                    <span className="me-1">عدد</span>
                  </p>
                </div>
                <div className="col-12 px-0">
                  {this.state.order.items.map((product, p) => (
                    <div key={p} className="col-12 p-0 border-bottom">
                      <ProductCard
                        image={product.image}
                        product={product.product}
                        payable_price={product.payable_price}
                        quantity={product.quantity}
                        isOrder={true}
                        shopUid={this.state.order.uid}
                      />
                    </div>
                  ))}
                </div>
              </div>
            )
          ) : (
            <Spinner />
          )}
        </body>
      </div>
    );
  }
}

export default OrderDetail;
